<template>
  <div class="box_phone_valid">
    <div class="form-group">
      <input
        type="tel"
        placeholder="+7(999)-999-99-99"
        :class="{ error_input: errors.phone }"
        v-model="orderDetails.phone"
        @keypress="filterPhone"
        @input="handlePhoneInput($event)"
        @blur="validatePhone"
        class="input_form_order"
      />

      <span v-if="errors.phone" class="error">{{ errors.phone }}</span>
    </div>
    <button @click="submitOrder" class="button_pay">
      <span>ЗАКАЗАТЬ ЗАМЕР  </span>
    </button>
    <p class="text_policy_confidentiality">
      Нажимая кнопку, вы соглашаетесь с
      <span class="text_policy_confidentiality_underline">
        Политикой конфиденциальности</span
      >
    </p>
  </div>
</template>
<script>
export default {
  props: {
    selectedOptions: Object, // Получаем выбранные параметры
  },
  data() {
    return {
      orderDetails: {
        phone: "",
      },
      errors: {},
    };
  },

  methods: {
    handlePhoneInput(event) {
      this.formatPhone(event); // Форматируем номер телефона
      this.clearError("phone"); // Убираем ошибку, если она была
    },
    clearError(field) {
      if (this.errors[field]) {
        delete this.errors[field];
      }
    },
    filterPhone(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      const allowedRegex = /^[\d+]*$/; // Разрешаем только цифры и знак "+"

      // Разрешаем удаление символов (Backspace/Delete)
      if (event.key === "Backspace" || event.key === "Delete") {
        return;
      }

      const digitsCount = this.orderDetails.phone.replace(/[^0-9]/g, "").length;
      if (!char.match(allowedRegex) || digitsCount >= 11) {
        event.preventDefault(); // Запрещаем ввод
      }
    },

    formatPhone(event) {
      // Проверяем, была ли нажата клавиша Backspace
      if (event && event.inputType === "deleteContentBackward") {
        return; // Не применяем форматирование, если происходит удаление
      }

      // Удаляем все символы, кроме цифр и "+"
      let cleaned = this.orderDetails.phone.replace(/[^0-9+]/g, "");

      // Проверяем, если поле полностью очищено, останавливаем обработку
      if (cleaned === "") {
        this.orderDetails.phone = "";
        return;
      }

      // Ограничиваем количество цифр до 11
      if (cleaned.startsWith("+7")) {
        cleaned = "+7" + cleaned.slice(2, 12); // Для номера, начинающегося с +7
      } else if (cleaned.startsWith("8")) {
        cleaned = "8" + cleaned.slice(1, 11); // Для номера, начинающегося с 8
      } else if (cleaned.startsWith("7")) {
        cleaned = "+7" + cleaned.slice(1, 11); // Для номера, начинающегося с 7
      }

      // Применяем форматирование только если длина больше 3 символов
      if (cleaned.startsWith("+7")) {
        cleaned = cleaned
          .replace(/^(\+7)(\d{0,3})/, "$1($2") // +7(XXX
          .replace(/(\(\d{3})/, (match, p1) => {
            return cleaned.length > 4 ? `${p1}) ` : p1; // Добавляем `)` и пробел
          })
          .replace(/(\)\s\d{0,3})/, "$1") // +7(XXX) YYY
          .replace(/(\s\d{3})(\d{0,2})/, "$1-$2") // +7(XXX) YYY-ZZ
          .replace(/(-\d{2})(\d{0,2})/, "$1-$2"); // +7(XXX) YYY-ZZ-WW
      } else if (cleaned.startsWith("8")) {
        cleaned = cleaned
          .replace(/^(8)(\d{0,3})/, "$1($2") // 8(XXX
          .replace(/(\(\d{3})/, (match, p1) => {
            return cleaned.length > 4 ? `${p1}) ` : p1; // Добавляем `)` и пробел
          })
          .replace(/(\)\s\d{0,3})/, "$1") // 8(XXX) YYY
          .replace(/(\s\d{3})(\d{0,2})/, "$1-$2") // 8(XXX) YYY-ZZ
          .replace(/(-\d{2})(\d{0,2})/, "$1-$2"); // 8(XXX) YYY-ZZ-WW
      }

      // Обновляем значение номера
      this.orderDetails.phone = cleaned;
    },

    validatePhone() {
      const phoneRegex = /^(\+7|8)\(\d{3}\) \d{3}-\d{2}-\d{2}$/; // Проверяем правильный формат
      if (!this.orderDetails.phone) {
        this.errors.phone = "Обязательное поле";
      } else if (!this.orderDetails.phone.match(phoneRegex)) {
        this.errors.phone = "Введите корректный номер";
      } else {
        delete this.errors.phone; // Удаляем ошибку, если валидация пройдена
      }
    },
    validateForm() {
      this.validatePhone();
      return Object.keys(this.errors).length === 0;
    },
    submitOrder() {
      if (this.validateForm()) {
        console.log("Телефон:", this.orderDetails.phone);
        this.sendOrder();
      }
    },
    sendOrder() {
      return fetch("/api/sendOrder", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({
          phone: this.orderDetails.phone
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          this.orderNumber = data.orderNumber;
          return data;
        });
    },
  },
};
</script>
<style>
.box_phone_valid {
  display: flex;
  gap: 0.2rem;
  flex-direction: column;
  width: fit-content;
}
.input_form_order {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 1.9rem;
  letter-spacing: 0%;
  text-align: left;
  border-bottom: 0.05rem solid rgb(255, 255, 255);
  padding-bottom: 0.2rem;
  width: 100%;
  margin-bottom: 1rem;
}
.form-group {
  position: relative;
}
.error {
  position: absolute;
  bottom: 0rem;
  left: 0px;
  color: rgb(236, 79, 51);
  font-family: Roboto;
  font-size: 0.7rem;
  font-weight: 400;
  line-height: 0.8rem;
  letter-spacing: 0%;
  text-align: left;
}
.error_input {
  border-bottom: 0.08rem solid rgb(227, 49, 79);
  color: rgb(227, 49, 79); /* Красный текст */
}
.button_pay {
  position: relative;
  width: 100%;
  height: 3rem;
  border-radius: 4rem;
  background: linear-gradient(
    90deg,
    rgb(205, 127, 50),
    rgb(165, 105, 42) 102.477%
  );
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.button_pay::before {
  content: "";
  position: absolute;
  top: 0;
  left: -150%;
  width: 150%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 204, 102, 0) 0%,
    rgba(255, 204, 102, 0.9) 50%,
    rgba(255, 204, 102, 0) 100%
  );
  filter: blur(4px);
  animation: wave 2s infinite linear;
  z-index: 0;
}

.button_pay span {
  color: rgb(255, 255, 255);
  position: relative;
  z-index: 1;
}


.text_policy_confidentiality,
.text_policy_confidentiality_underline {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: -1%;
  text-align: left;
}
.text_policy_confidentiality_underline {
  text-decoration: underline;
}
@media (max-width: 767px) {
  .box_phone_valid {
    width: 16.5rem;
  }
  .input_form_order {
    font-size: 1.14rem;
    font-weight: 400;
    line-height: 1.36rem;
    margin-bottom: 0.8rem;
  }
  .button_pay {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.14rem;
    height: 2.71rem;
  }
  .error {
    bottom: -0rem;
  }
  .text_policy_confidentiality,
  .text_policy_confidentiality_underline {
    font-size: 0.76rem;
    font-weight: 400;
    line-height: 0.86rem;
    letter-spacing: -0.05rem;
  }
}
</style>





